import React, { useState } from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  makeStyles,
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';


const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const DownloadModal = ({open, setOpen}) => {
  const classes = useStyles();
  const date = new Date();
  date.setMonth(date.getMonth() - 1);
  const [startDate, setStartDate] = useState(date);
  const [endDate, setEndDate] = useState(new Date());

  const handleDownloadQuoteReport = () => {
    setOpen(false);
  };

  const handleChangePeriod = (months: number) => {
    const date = new Date(endDate);
    date.setMonth(date.getMonth() - months);
    setStartDate(date);
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="confirm-dialog"
    >
      <MuiDialogTitle disableTypography className={classes.root}>
        <Typography variant="h6">Download Quotes Report</Typography>
        <IconButton aria-label="close" className={classes.closeButton} onClick={() => setOpen(false)}>
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
      <DialogContent dividers className="text-center">
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            className="mb-4 mr-5"
            variant="inline"
            label="Start Date"
            autoOk
            format="MM/dd/yyyy"
            value={startDate}
            onChange={setStartDate}
            disableFuture
          />
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <DatePicker
            className="mb-4 mr-5"
            error={endDate < startDate}
            helperText={endDate < startDate && 'End Date cant be less than Start Date'}
            variant="inline"
            label="End Date"
            autoOk
            format="MM/dd/yyyy"
            value={endDate}
            onChange={setEndDate}
            disableFuture
          />
        </MuiPickersUtilsProvider>
        <div className="mb-5">
          <Chip className="mr-2" size="small" label="1 Year" onClick={() => handleChangePeriod(12)} />
          <Chip className="mr-2" size="small" label="6 Months" onClick={() => handleChangePeriod(6)} />
          <Chip className="mr-2" size="small" label="3 Months" onClick={() => handleChangePeriod(3)} />
          <Chip className="mr-2" size="small" label="1 Month" onClick={() => handleChangePeriod(1)} />
        </div>
        <Button
          variant="contained"
          color="primary"
          className="w-300"
          disabled={endDate < startDate}
          onClick={handleDownloadQuoteReport}
        >
          Download Report
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadModal;
